import React, { Component } from "react"
import ExpenseTypeCardBasic from "components/expenseTypes/layout/ExpenseTypeCardBasic"

export class ExpenseTypePageBasic extends Component {
    render() { return (<ExpenseTypeCardBasic />) }
}
